import { Component, OnInit } from '@angular/core';
import { FiltroPadrao } from 'src/app/shared/models/filtro-padrao/filtroPadrao';

//Services
import { BaseComponent } from "components/base/base.component";
import { BreadcrumbComponent } from 'components/breadcrumb/breadcrumb.component';
import { FiltroPadraoComponent } from 'components/filtro-padrao/filtro-padrao.component';
import { FiltroService } from 'src/app/shared/services/filtro.service';

@Component({
    selector: 'app-registra-check-out',
    templateUrl: './registra-check-out.component.html',
    styleUrls: ['./registra-check-out.component.scss'],
    imports:[FiltroPadraoComponent, BreadcrumbComponent],
    standalone: true
})
export class RegistraCheckOutComponent extends BaseComponent implements OnInit {

      constructor(
        private filtroService: FiltroService
      ) {
        super();
      }


  ngOnInit(): void {
    // Inicialização do componente
  }

    async listeningFiltroEmitter(eventFilter: FiltroPadrao) {

      this.setFilters(eventFilter);

      this.filtroService.atualizaFiltro(eventFilter);

    }
      setFilters(event: FiltroPadrao) {
        this.filtros = event;

      }
}
